import variables from 'styled-up/dist/variables';

variables.fontFamily.primary = 'IRANSans';
variables.fontFamily.secondary = 'IRANSans';

variables.fontSize.small = 11;
variables.fontSize.normal = 12;
variables.fontSize.large = 14;

variables.color.white = '#ffffff';
variables.color.primary = '#35A0DD';
variables.color.primaryLight = '#cee8f7';
variables.color.secondary = '#9eb3bf';
variables.color.secondaryLight = '#ebeff2';
variables.color.tertiary = '#bec3d3';
variables.color.info = '#35A0DD';
variables.color.infoLight = '#cee8f7';
variables.color.success = '#8AE278';
variables.color.successLight = '#ebfffb';
variables.color.error = '#F4726B';
variables.color.errorLight = '#fff2f5';
variables.color.warning = '#f1d520';
variables.color.warningLight = '#faf0b0';
variables.color.disabled = '#cccccc';
variables.color.disabledLight = '#f0f0f0';

export default variables;
